import React, { useState, useEffect } from "react";
import api from "../utils/api.utils";
import { useNavigate, useParams } from "react-router-dom";
import { NavbarAdmin, FooterAdmin, MsgSucess } from "../components/index.js";
import { ButtonFinalizar } from "../components/ButtonFinalizar";

import loadingGif from "../imgs/loading-state.gif";
import { Button, Modal, Toast, Form, InputGroup } from "react-bootstrap";

import "./Admin.css";

export const ViewDenuncia = ({ loading, setLoading, message, setMessage }) => {
  const { id } = useParams();
  const [show, setShow] = useState(false);

  const navigate = useNavigate();

  const handleClose = () => setShow(false);
  const handleCloseFinalizar = () => setFinalizar(false);
  const handleShow = () => setShow(true);
  const handleShowFinalizar = () => setFinalizar(true);

  const [denuncia, setDenuncia] = useState();

  const [assumir, setAssumir] = useState();
  const [finalizar, setFinalizar] = useState();

  const [showMessage, setShowMessage] = useState(false);

  const handleCloseSendMessage = () => setShowMessage(false);

  let status;

  const [messageUser, setMessageUser] = useState("");

  const [users, setUsers] = useState([]);

  let userId = localStorage.getItem("userId");

  useEffect(() => {
    const getUser = async () => {
      try {
        const data = await api.getUserLogged(userId);
        setUsers(data);
      } catch (error) {
        console.log(error, "Error to get user");
      }
    };
    getUser();
  }, [userId]);
  let userName;
  users.forEach((user) => {
    userName = user.full_name;
  });

  useEffect(() => {
    const getDenuncia = async () => {
      try {
        const data = await api.getDenuncia(id);
        setDenuncia(data);
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      } catch (error) {
        console.log(error, "Error to get Denuncias");
      }
    };
    getDenuncia();

    const getAuditById = async () => {
      try {
        const data = await api.getAuditById(id);
        if (data[0].responsible_id !== undefined) setAssumir(false);
      } catch (error) {
        console.log(error, "Error to get Audit");
      }
    };
    getAuditById();
  }, [loading, setLoading, id, userId]);

  useEffect(() => {
    setTimeout(() => {
      setMessage(null);
    }, 5000);
  }, [message, setMessage]);

  const handleAssumir = async (e) => {
    const userId = localStorage.getItem("userId");

    try {
      const newAudit = await api.addAudit(id, { userId });
      navigate(`/admin/denuncia/${id}`);

      return newAudit;
    } catch (error) {
      console.log(error);
      setMessage(error);
    }
  };
  const handleFinalizar = async (e) => {
    const userId = localStorage.getItem("userId");

    const tipo = e.target.innerText;

    try {
      const newAudit = await api.endAudit(id, userId, { tipo });
      if (newAudit) {
        navigate(`/admin/denuncia/${id}`);
      }
    } catch (error) {
      console.log(error);
      setMessage(error);
    }
  };

  const handleSimClick = (e) => {
    if (e) {
      e.preventDefault();
      handleSendMessage("sim");
    }
  };
  const handleNaoClick = (e) => {
    e.preventDefault();
    handleSendMessage("nao");
  };

  const handleShowMessage = (e) => {
    e.preventDefault();
    setShowMessage(true);
  };

  const handleSendMessage = async (tipo) => {
    setMessageUser(messageUser);

    let changeEtapa;

    if (tipo === "sim") {
      changeEtapa = true;
    }
    if (tipo === "nao") {
      changeEtapa = false;
    }

    try {
      const newMessage = await api.sendMessage(id, {
        messageUser,
        userId,
        userName,
        changeEtapa,
      });
      console.log(newMessage);
      navigate(0);
    } catch (error) {
      console.log(error);
      setMessage(error);
    }
  };

  /* const formatDate = (myDate) => {
    const newDate = new Intl.DateTimeFormat("default", {
      timeZone: "America/Sao_Paulo",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(new Date(myDate));

    const [month, day, year] = newDate.split("/");

    const formatedDate = `${day}/${month}/${year}`;

    return formatedDate;
  };*/
  return (
    <div>
      <NavbarAdmin />
      {message && <MsgSucess>{message}</MsgSucess>}
      {!loading ? (
        denuncia?.map((denuncia, index) => {
          let anoDen = denuncia.createdAt.slice(0, 4);
          const now = new Date(); // Data de hoje
          const past = new Date(denuncia.createdAt); // Outra data no passado
          const diff = Math.abs(now.getTime() - past.getTime()); // Subtrai uma data pela outra
          const days = Math.ceil(diff / (1000 * 60 * 60 * 24)); // Divide o total pelo total de milisegundos correspondentes a 1 dia. (1000 milisegundos = 1 segundo).

          if (denuncia.status === "cadastrada") status = "warning";
          if (denuncia.status.slice(0, 10) === "finalizada")
            status = "secondary";
          if (denuncia.status === "em-andamento") status = "info";

          if (days >= 2 && denuncia.status.slice(0, 10) !== "finalizada") {
            status = "danger";
          }

          if (days >= 2 && denuncia.status.slice(0, 10) !== "finalizada") {
            status = "danger";
            denuncia.status = `Cadastrada há ${days} dias`;
          }

          let tipoDenuncia;
          if (denuncia.category === "assedio-moral") {
            tipoDenuncia = "Assédio Moral";
          }
          if (denuncia.category === "assedio-sexual") {
            tipoDenuncia = "Assédio Sexual";
          }
          if (denuncia.category === "gestao-inadequada") {
            tipoDenuncia = "Gestão Inadequada";
          }
          if (denuncia.category === "discrimacao") {
            tipoDenuncia = "Discriminação";
          }
          if (denuncia.category === "fraude") {
            tipoDenuncia = "Fraude";
          }
          if (denuncia.category === "corrupcao") {
            tipoDenuncia = "Corrupção";
          }
          if (denuncia.category === "conflito-interesse") {
            tipoDenuncia = "Conflito de interesses";
          }
          if (denuncia.category === "atividades-ilicitas") {
            tipoDenuncia = "Atividades Ilícitas";
          }
          if (denuncia.category === "riscos-operacionais") {
            tipoDenuncia = "Riscos Operacionais";
          }
          return (
            <div key={index}>
              <div className="mx-3 mt-3">
                <h4 className="d-flex align-items-center justify-content-between ">
                  <div className="d-flex align-items-center">
                    <i className="bi bi-megaphone-fill mx-3"></i>
                    <span>Visualização de denúncia:</span> &nbsp;
                    <div className="p-2 rounded alert-secondary">
                      {" "}
                      {anoDen}DEN{denuncia.protocolo_id}
                    </div>
                  </div>
                  <span className={`btn btn-${status}`}>
                    {denuncia.status.toUpperCase().replace("-", " ")}
                  </span>
                </h4>
              </div>
              <hr />

              <div className="d-flex w-100 justify-content-end  px-3">
                {denuncia.status.slice(0, 10) !== "finalizada" ? (
                  !denuncia.responsible_id ? (
                    <Button
                      className="mx-3"
                      variant="primary"
                      onClick={handleShow}
                    >
                      Assumir
                    </Button>
                  ) : (
                    <Button
                      className="mx-3"
                      variant="primary"
                      onClick={handleShowFinalizar}
                    >
                      Finalizar
                    </Button>
                  )
                ) : (
                  <></>
                )}
              </div>
              <div className="align-mobile d-flex flex-nowrap">
                <div className="card w-50 m-3">
                  <div className="d-flex card-header justify-content-between align-items-center">
                    <h5 className=" mb-0">Dados da denúncia</h5>
                  </div>
                  <div className="card-body">
                    <table className="table table-borderless">
                      <tbody>
                        <tr>
                          <td> Data da denúncia:</td>
                          <td>
                            <b>
                              {new Intl.DateTimeFormat("default", {
                                timeZone: "America/Sao_Paulo",
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: false,
                              }).format(new Date(denuncia.createdAt))}
                              h
                            </b>
                          </td>
                        </tr>
                        <tr>
                          <td>Categoria:</td>
                          <td>
                            <b>{tipoDenuncia}</b>
                          </td>
                        </tr>
                        <tr>
                          <td>Envolvidos:</td>
                          <td>
                            <b>{denuncia.involved || "Vazio"}</b>
                          </td>
                        </tr>
                        <tr>
                          <td>Testemunhas:</td>
                          <td>
                            <b>{denuncia.witness || "Vazio"}</b>
                          </td>
                        </tr>
                        <tr>
                          <td>Conversou sobre o ocorrido com:</td>
                          <td>
                            <b>{denuncia.talkedAbout || "Vazio"}</b>
                          </td>
                        </tr>
                        <tr>
                          <td>Descrição da denúncia:</td>
                          <td>
                            <b>{denuncia.details}</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="card w-50 m-3">
                  <h5 className="card-header">Dados do(a) reclamante</h5>
                  <div className="card-body">
                    <table className="table table-borderless">
                      <tbody>
                        <tr>
                          <td> Denunciante:</td>
                          <td>
                            <b>{denuncia.name || "Anônimo"}</b>
                          </td>
                        </tr>
                        {denuncia.name && (
                          <>
                            <tr>
                              <td>Funcionário do departamento:</td>
                              <td>
                                <b>{denuncia.role || "-"}</b>
                              </td>
                            </tr>
                            <tr>
                              <td>Telefone:</td>
                              <td>
                                <b>{denuncia.telephone}</b>
                              </td>
                            </tr>
                            <tr>
                              <td>E-mail:</td>
                              <td>
                                <b>{denuncia.email}</b>
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {denuncia.status !== "cadastrada" ? (
                <div className="align-mobile auditoria d-flex">
                  <div className="card w-100 m-3">
                    <div className="d-flex card-header justify-content-between align-items-center">
                      <h5 className=" mb-0 w-100 text-center">Mensagens</h5>
                    </div>
                    <div className="card-body">
                      <Toast key={index} className=" mb-2 w-75">
                        <Toast.Header closeButton={false}>
                          <i className="bi bi-person-circle"> </i>
                          <strong className="me-auto mx-2">
                            {denuncia.name || <span>Anônimo</span>}
                          </strong>
                          <small>
                            {new Intl.DateTimeFormat("default", {
                              timeZone: "America/Sao_Paulo",
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            }).format(new Date(denuncia.createdAt))}
                            h
                          </small>
                        </Toast.Header>
                        <Toast.Body>{denuncia.details}</Toast.Body>
                      </Toast>
                      {denuncia?.messages_id.map((message, index) => {
                        let styleOuvi = "";
                        if (message.userId) {
                          styleOuvi = "styleOuvidoria";
                        }
                        return (
                          <Toast
                            key={index}
                            className={`${styleOuvi} mb-2 w-75`}
                          >
                            <Toast.Header closeButton={false}>
                              <i className="bi bi-person-circle"> </i>
                              <strong className="me-auto mx-2">
                                {" "}
                                {message.userName}
                                {message.userId ? " (comitê)" : ""}
                              </strong>
                              <small>
                                {new Intl.DateTimeFormat("default", {
                                  timeZone: "America/Sao_Paulo",
                                  year: "numeric",
                                  month: "2-digit",
                                  day: "2-digit",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: false,
                                }).format(new Date(message.createdAt))}
                                h
                              </small>
                            </Toast.Header>
                            <Toast.Body>{message.descricao}</Toast.Body>
                          </Toast>
                        );
                      })}
                      {denuncia.status.slice(0, 10) !== "finalizada" ? (
                        <>
                          {denuncia.etapa === "ouvidoria" ? (
                            <form className="w-75 mt-3">
                              <p>Digite aqui sua mensagem:</p>
                              <InputGroup className="mb-3 w-100 flex-nowrap">
                                <Form.Control
                                  as="textarea"
                                  className="w-100"
                                  rows={3}
                                  atial-label="Message"
                                  value={messageUser}
                                  onChange={(e) =>
                                    setMessageUser(e.target.value)
                                  }
                                />
                                <button
                                  className="btn btn-primary"
                                  onClick={handleShowMessage}
                                >
                                  <i className="bi bi-send-fill"></i>
                                </button>
                              </InputGroup>
                            </form>
                          ) : (
                            <>Aguardando resposta do reclamante.</>
                          )}
                        </>
                      ) : (
                        <span>Denúncia finalizada!</span>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
              <div className="align-mobile auditoria d-flex">
                <div className="card w-100 m-3">
                  <div className="d-flex card-header justify-content-between align-items-center">
                    <h5 className=" mb-0 w-100 text-center">Auditoria</h5>
                  </div>
                  <div className="card-body">
                    <table className="table table-borderless">
                      <thead>
                        <tr>
                          <th>DATA</th>
                          <th className="no-mobile">OPERAÇÃO</th>
                          <th>DESCRIÇÃO</th>
                          <th>USUÁRIO</th>
                        </tr>
                      </thead>
                      <tbody>
                        {denuncia.audits.map((audit, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {new Date(
                                  audit.createdAt.slice(0, -1)
                                ).toLocaleDateString("pt-br", {
                                  day: "numeric",
                                  month: "numeric",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit",
                                })}
                                h
                              </td>
                              <td className="no-mobile">{audit.operacao}</td>
                              <td>{audit.descricao}</td>
                              <td>{audit.userName}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* Modal */}
              <Modal
                style={{ marginTop: "20%" }}
                show={show}
                onHide={handleClose}
              >
                <form onSubmit={handleAssumir}>
                  <Modal.Header closeButton>
                    <h6>Deseja assumir o controle desta denúncia?</h6>
                  </Modal.Header>
                  <Modal.Body>
                    <p className="d-flex flex-column">
                      <span>
                        Protocolo:{" "}
                        <b>
                          {" "}
                          {anoDen}DEN{denuncia.protocolo_id}
                        </b>
                      </span>
                      <span>
                        Data da denúncia:{" "}
                        <b>
                          {new Date(
                            denuncia.createdAt.slice(0, -1)
                          ).toLocaleDateString("pt-br", {
                            day: "numeric",
                            month: "numeric",
                            year: "numeric",
                          })}
                        </b>
                      </span>
                      <span>
                        Denúncia de <b> {tipoDenuncia}</b>
                      </span>
                      <span>
                        Reclamante: <b> {denuncia.name || "Anônimo"}</b>
                      </span>
                    </p>
                  </Modal.Body>
                  <Modal.Footer>
                    <button className="btn btn-primary" type="submit">
                      Sim
                    </button>
                    <Button variant="secondary" onClick={handleClose}>
                      Não
                    </Button>
                  </Modal.Footer>
                </form>
              </Modal>
              <Modal
                style={{ marginTop: "20%" }}
                show={finalizar}
                onHide={handleCloseFinalizar}
                aria-labelledby="example-modal-sizes-title-lg"
                size="lg"
              >
                <form>
                  <Modal.Header closeButton>
                    <h6>Deseja finalizar esta denúncia?</h6>
                  </Modal.Header>
                  <Modal.Body>
                    <p className="d-flex flex-column">
                      <span>
                        Protocolo n. <b> {denuncia.protocolo_id}</b>
                      </span>
                      <span>
                        Data da denúncia:{" "}
                        <b>
                          {new Date(
                            denuncia.createdAt.slice(0, -1)
                          ).toLocaleDateString("pt-br", {
                            day: "numeric",
                            month: "numeric",
                            year: "numeric",
                          })}
                        </b>
                      </span>
                      <span>
                        Denúncia de <b> {tipoDenuncia}</b>
                      </span>
                      <span>
                        Reclamante: <b> {denuncia.name || "Anônimo"}</b>
                      </span>
                      <span>
                        Setor denunciado: <b> {denuncia.sector}</b>
                      </span>
                    </p>
                  </Modal.Body>
                  <Modal.Footer>
                    <ButtonFinalizar
                      tipo="Procedente"
                      handleFinalizar={handleFinalizar}
                    />
                    <ButtonFinalizar
                      tipo="Improcedente"
                      handleFinalizar={handleFinalizar}
                    />
                    <ButtonFinalizar
                      tipo="Dados Insuficientes"
                      handleFinalizar={handleFinalizar}
                    />
                    <Button variant="secondary" onClick={handleCloseFinalizar}>
                      Não Finalizar
                    </Button>
                  </Modal.Footer>
                </form>
              </Modal>
              {/*MODAL mensagem */}
              <Modal
                style={{ marginTop: "20%" }}
                show={showMessage}
                onHide={handleCloseSendMessage}
                // size="lg"
              >
                <form onSubmit={handleSendMessage}>
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body className="d-flex flex-column">
                    <h5>Deseja manter a Denúncia na sua etapa?</h5>
                    <span>
                      Ex: Se ainda estiver analisando a situação e não puder
                      fornecer uma resposta definitiva de imediato, por favor,
                      responda "sim".
                    </span>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={(e) => handleSimClick(e)}
                    >
                      Sim
                    </Button>
                    <Button variant="primary" onClick={handleNaoClick}>
                      Não
                    </Button>
                  </Modal.Footer>
                </form>
              </Modal>
            </div>
          );
        })
      ) : (
        <div className="d-flex justify-content-center">
          <img style={{ width: "100px" }} src={loadingGif} alt="Loading gif" />
        </div>
      )}
      <hr className="espacamento-100" />
      <FooterAdmin />
    </div>
  );
};
